<template>
  <div>
<!--    <el-dialog :visible.sync="showSetDomain">-->
<!--      <el-form :model="dataSet">-->
<!--        <el-form-item label="域名" ><el-input v-model="dataSet.domain" size="mini" style="width: 600px;"></el-input></el-form-item>-->
<!--        <el-form-item label="状态">-->
<!--          <el-select v-model="dataSet.valid" label="状态">-->
<!--            <el-option value = 1 label="开">开</el-option>-->
<!--            <el-option value = 0 label="关">关</el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->

<!--        <el-form-item>-->
<!--          <el-button type="success" size="mini" @click="subDomain()">提交</el-button>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--    </el-dialog>-->

<!--    <el-button size="mini"  type="info"  @click="showDiv()">添加</el-button>-->

    <el-table :data="MediaList" v-loading="loading">
      <el-table-column prop="media_id" label="media_id" />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="time" width="150px" label="时间" />
      <el-table-column  width="70px" label="地址">
        <template slot-scope="scope">
          <el-link
                  :href="scope.row.url"
                  type="primary"
                  target="_blank"
          >地址</el-link>
        </template>
      </el-table-column>
    </el-table>
    <page-bar :currentPageCount="MediaList.length" @page-changed="loadData"></page-bar>
  </div>
</template>

<script>
  import PageBar from "../ui/PageBar";
  import request from "../../api/request";

  export default {
     name: "MediaList",
     components: {
          PageBar
      },
    data() {
      return {
        loading: true,
        showSetDomain: false,
        MediaList:[],
        dataSet:{},
        searchData: {},
        filter: {}
      };
    },
    created() {
      this.loadData([0, 10]);
    },
    methods: {
      async loadData(range) {
        request.tools
                .post("wx_get_media_id", {
                    type: "image",
                    range: range,
                })
                .then(r => {
                  this.MediaList = r.data.list;
                  this.loading = false;
                });
      },
      showDiv () {
        this.showSetDomain = true
      },


    }
  };
</script>